/**
 *@author 刘云飞
 *@email  1020450921@qq.com
 *@description 新增对定死的jsonpCallBackName 做兼容 fuck
 *@date 2020-09-02 17:01:06
 */

let root = window,
  doc = root.document
/**
 * 序列化 请求参数
 */
const parseParams = data => {
  try {
    let tempArr = []
    for (const [key, value] of Object.entries(data)) {
      tempArr.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
    // for (let i in data) {
    //   let key = encodeURIComponent(i)
    //   let value = encodeURIComponent(data[i])
    //   tempArr.push(`${key}=${value}`)
    // }
    let urlParamsStr = tempArr.join('&')
    return urlParamsStr
  } catch (err) {
    return ''
  }
}

/**
 * 支持普通的uri?callback=func形式
 * 兼容uri_{callback}.htm的形式
 * @param {String} url
 * @param {Object} data
 * @param {Function} callback
 * @param {string} callBackName
 */
export function jsonp(url, data, callback, callBackName = null) {
  let id = Math.random(0, 1).toString().substr(2)
  let params = parseParams(data)
  let prefixCallback = callBackName || `callbackFunc${id}`

  root[prefixCallback] = res => {
    // console.log(res);
    callback && callback(res)
    setTimeout(() => {
      let t = doc.getElementById(`sc_${id}`)
      t.parentNode.removeChild(t)
      root[prefixCallback] = null
    }, 1000)
  }

  let sc = doc.createElement('script')
  sc.setAttribute('id', `sc_${id}`)
  sc.setAttribute('type', 'text/javascript')
  if (url.indexOf('{callback}') !== -1) {
    // 针对icps价格接口做适配
    sc.setAttribute('src', url.replace('{callback}', prefixCallback))
  } else {
    sc.setAttribute(
      'src',
      `${
        url +
        (url.lastIndexOf('?') !== -1 ? '&' : '?') +
        (params.length
          ? params + '&callback='.concat(prefixCallback)
          : 'callback='.concat(prefixCallback))
      }&callBack=${prefixCallback}`
    )
  }
  doc.head.appendChild(sc)
}
/**
 * jsonp-promise
 * @param {string} url
 * @param {object} data
 * @param {string } callBackName
 */
export function jsonpP(url, data = {}, callBackName = null) {
  return new Promise((resolve, reject) => {
    jsonp(
      url,
      data,
      res => {
        // if (+res.code === 0) {
        //     resolve(res.data)
        // } else {
        //     reject(res.message)
        // }
        resolve(res)
      },
      callBackName
    )
  })
}
